import { Component, OnInit, afterNextRender } from '@angular/core';
import { FeriasBaseComponent } from '../../ferias-base.component';
import { Router } from '@angular/router';
import { AlertMessageService } from '@sigepe/sigepe-template';
import { SituacaoParcelaFeriasEnum } from 'src/app/components/shared/enums/situacao-parcela-ferias.enum';
import { ConfirmationService, MenuItem as MenuItem_PrimeNG } from 'primeng/api';
import _ from 'lodash';
import { getDateFromYYYYMMDD, isValidDate } from 'src/app/components/shared/date-utils';
import { addDays, addYears, differenceInDays } from 'date-fns';
import { SituacaoFuncionalEnum } from 'src/app/components/shared/enums/situacao-funcional.enum';
import { DataFormatadaPipe } from 'src/app/components/shared/pipes/dataFormatada.pipe';
import { ExercicioSelecionado, ExerciciosService, ParcelaInterrompidaFerias } from 'src/app/services/exercicios.service';
import { Message } from 'src/app/components/shared/message';
import { formatarMensagem } from 'src/app/components/shared/string-utils';

export interface ParcelaFeriasParaInterrupcao {
    id: number;
    ordem: number;
    geracao: number;
    dataInicio: Date;
    dataFim: Date;
    quantidadeDias: number;
    situacao: {
        //Vindo da enum SituacaoParcelaFeriasEnum
        descricao: string;
        codigoCor: string;
    };
    adiantamentoSalarial: {
        valor: boolean;
    };
    abonoPecuniario: {
        valor: boolean;
    };
    adiantamentoDecimoTerceiro: {
        valor: boolean;
    };
    parcelasDesconto: number;
    podeInterromper: boolean;
    selecionadaParaInterrupcao: boolean;
    dataInterrupcao: Date;
    motivoLegal: string;
    justificativaInterrupcao: string;
    documentoLegal: string;
    dataPublicacaoDocumentoLegal: Date;
    dataMinimaInterrupcao: Date;
    idParcelaPai?: number;
    validacao: {
        dataInterrupcaoInvalida: boolean;
        dataInterrupcaoForaPeriodoFerias: boolean;
        dataPublicacaoInvalida: boolean;
        justificativaInterrupcaoInvalida: boolean;
    };
}

export interface ParcelaFeriasParaReprogramacaoHomologacao {
    id?: number;
    ordem: number;
    geracao: number;
    dataInicio?: Date;
    dataFim?: Date;
    quantidadeDias: number;
    situacao: {
        descricao: string;
        codigoCor: string;
    };
    validacao: {
        sobreposto: boolean;
        foraOrdem: boolean;
        foraJanelaProgramacao: boolean;
        quantidadeInsuficienteDias: boolean;
        dataInvalida: boolean;
    };
    idParcelaPai?: number;
    dataMinimaReprogramacao: Date;
    emAcumuloSegundoPeriodo?: boolean;
    emAcumuloTerceiroPeriodo?: boolean;
}

export interface ParcelaFeriasAgregadasParaValidacao {
    id?: number;
    ordem: number;
    geracao: number;
    dataInicio?: Date;
    dataFim?: Date;
    quantidadeDias: number;
    idParcelaPai?: number;
    situacao?: string;
    adiantamentoSalarial?: boolean;
    parcelasDesconto?: number;
    abonoPecuniario?: boolean;
    adiantamentoDecimoTerceiro?: boolean;
    emAcumulo?: boolean;
    dataInterrupcao?: Date;
    motivoLegal?: string;
    justificativaInterrupcao?: string;
    documentoLegal?: string;
    dataPublicacaoDocumentoLegal?: Date;
    validacao: {
        sobreposto: boolean;
        foraJanelaProgramacao: boolean;
    };
    justificativaAcumulo?: string;
}

@Component({
    selector: 'app-interromper-ferias',
    templateUrl: './interromper-ferias.component.html',
    styleUrls: ['./interromper-ferias.component.scss']
})
export class InterromperFeriasComponent extends FeriasBaseComponent implements OnInit {
    submetido = false;
    houvePreenchimento = false;

    exercicioSelecionado: ExercicioSelecionado;

    parcelasFeriasParaInterrupcao: ParcelaFeriasParaInterrupcao[];
    novasParcelasFerias: ParcelaFeriasParaReprogramacaoHomologacao[];

    justificativaParaAcumuloFerias = '';
    justificativaParaAcumuloFeriasInvalida = false;

    dataMinimaParcela: Date;
    dataMaximaParcela: Date;

    itensWizard: MenuItem_PrimeNG[] | undefined;
    wizardActiveIndex = 0;

    constructor(
        private exerciciosService: ExerciciosService,
        alertaMsgService: AlertMessageService,
        private confirmationService: ConfirmationService,
        private dataFormatadaPipe: DataFormatadaPipe,
        private router: Router
    ) {
        super(alertaMsgService);

        this.exercicioSelecionado = this.router.getCurrentNavigation().extras.state.data;

        afterNextRender(() => {
            this.alterarTituloTemplate('Gerenciar Férias');
            this.alterarTextoBreadcrumb(1, 'Gerenciar Férias - Buscar Agente Público');
            this.rolarParaTopo();
        });
    }

    ngOnInit(): void {
        //Determinar a data mínima para a todas as parcelas a serem reprogramadas
        this.dataMinimaParcela = getDateFromYYYYMMDD(this.exercicioSelecionado.dataInicioPeriodoProgramacaoDisponivel ? this.exercicioSelecionado.dataInicioPeriodoProgramacaoDisponivel : this.exercicioSelecionado.dataInicioPeriodoProgramacao);
        this.dataMaximaParcela = getDateFromYYYYMMDD(this.exercicioSelecionado.dataFimPeriodoProgramacaoDisponivel ? this.exercicioSelecionado.dataFimPeriodoProgramacaoDisponivel : this.exercicioSelecionado.dataFimPeriodoProgramacao);

        //Adiciona mais um ano na dataMaximaParcela, pois pode haver acúmulo até o terceiro período
        this.dataMaximaParcela = addYears(this.dataMaximaParcela, 1);

        this.parcelasFeriasParaInterrupcao = [];
        this.novasParcelasFerias = [];

        this.exercicioSelecionado.parcelas.forEach(parcelaFerias => {
            if (parcelaFerias.ordem !== 99) {
                //Ignorar parcelas Canceladas
                this.parcelasFeriasParaInterrupcao.push(this.resgatarParcelaCorrente(parcelaFerias, 0));
            }
        });

        //remover as parcelas que não podem ser interrompidas
        this.parcelasFeriasParaInterrupcao = this.parcelasFeriasParaInterrupcao.filter(parcela => parcela.podeInterromper);

        //ordenar as parcelas
        this.parcelasFeriasParaInterrupcao.sort((a, b) => a.ordem - b.ordem);

        this.itensWizard = [
            {
                label: 'Preencher Interrupção'
            },
            {
                label: 'Reprogramar e Homologar'
            }
        ];
    }

    get regimeCeletistaOuAnistiado(): boolean {
        return SituacaoFuncionalEnum.CLT.id === this.exercicioSelecionado.siglaRegime || SituacaoFuncionalEnum.ANISTIADO.id === this.exercicioSelecionado.siglaRegime;
    }

    get homologacaoComAcumuloFerias(): boolean {
        return !this.regimeCeletistaOuAnistiado && this.novasParcelasFerias.some(parcela => parcela.emAcumuloSegundoPeriodo || parcela.emAcumuloTerceiroPeriodo);
    }

    get homologacaoComAcumuloFeriasNoTerceiroPeriodo(): boolean {
        return !this.regimeCeletistaOuAnistiado && this.novasParcelasFerias.some(parcela => parcela.emAcumuloTerceiroPeriodo);
    }

    get msgParcelaPrecisaSerSelecionada(): string {
        return 'Para avançar, é necessário selecionar ao menos uma parcela para interrupção.';
    }

    get msgCamposObrigatoriosNaoPreenchidos(): string {
        return Message.ERRO_CAMPOS_OBRIGATORIOS_NAO_PREENCHIDOS;
    }

    get msgJustificativaObrigatoria(): string {
        return Message.ERRO_JUSTIFICATIVA_OBRIGATORIA;
    }

    get msgJustificativaAcumuloFeriasObrigatoria(): string {
        return Message.ERRO_JUSTIFICATIVA_ACUMULO_FERIAS_OBRIGATORIA;
    }

    get msgJustificativaInvalida(): string {
        return Message.ERRO_JUSTIFICATIVA_TAMANHO_INVALIDO;
    }

    get msgCeletistaAnistiadoComParcelaForaPeriodoProgramacao(): string {
        return formatarMensagem(Message.ERRO_DATA_INICIO_PARCELA_FORA_DO_INTERVALO, {
            dataInicio: this.dataFormatadaPipe.transform(this.dataMinimaParcela),
            dataFim: this.dataFormatadaPipe.transform(this.dataMaximaParcela)
        });
    }

    get msgNaoCeletistaAnistiadoComParcelaForaPeriodoProgramacao(): string {
        return formatarMensagem(Message.ERRO_DATA_INICIO_PARCELA_FORA_DO_INTERVALO, {
            dataInicio: this.dataFormatadaPipe.transform(this.dataMinimaParcela),
            dataFim: this.dataFormatadaPipe.transform(this.dataMaximaParcela)
        });
    }

    getMsgCeletistaAnistiadoComParcelaForaPeriodoProgramacao(novaParcela: ParcelaFeriasParaReprogramacaoHomologacao): string {
        return formatarMensagem(Message.ERRO_DATA_INICIO_PARCELA_FORA_DO_INTERVALO, {
            dataInicio: this.dataFormatadaPipe.transform(this.dataMinimaParcela),
            dataFim: this.dataFormatadaPipe.transform(this.dataMaximaParcela)
        });
    }

    getMsgNaoCeletistaAnistiadoComParcelaForaPeriodoProgramacao(novaParcela: ParcelaFeriasParaReprogramacaoHomologacao): string {
        return formatarMensagem(Message.ERRO_DATA_INICIO_PARCELA_FORA_DO_INTERVALO, {
            dataInicio: this.dataFormatadaPipe.transform(novaParcela.dataMinimaReprogramacao),
            dataFim: this.dataFormatadaPipe.transform(this.dataMaximaParcela)
        });
    }

    getMsgDataInterrupcaoForaPeriodoFerias(parcela: ParcelaFeriasParaInterrupcao): string {
        return formatarMensagem(Message.ERRO_DATA_INICIO_PARCELA_FORA_DO_INTERVALO, {
            dataInicio: this.dataFormatadaPipe.transform(parcela.dataMinimaInterrupcao),
            dataFim: this.dataFormatadaPipe.transform(parcela.dataFim)
        });
    }

    get msgParcelasSobrepostas(): string {
        return Message.ERRO_PARCELAS_COM_DATAS_SOBREPOSTAS;
    }

    resgatarParcelaCorrente(parcelaFerias: any, profundidade: number): ParcelaFeriasParaInterrupcao {
        if (!parcelaFerias.parcelaFilha) {
            return {
                id: parcelaFerias.id,
                idParcelaPai: parcelaFerias.idParcelaPai,
                ordem: parcelaFerias.ordem,
                geracao: profundidade,
                dataInicio: getDateFromYYYYMMDD(parcelaFerias.dataInicio),
                dataFim: getDateFromYYYYMMDD(parcelaFerias.dataFim),
                quantidadeDias: parcelaFerias.quantidadeDias,
                situacao: {
                    descricao: SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).descricao,
                    codigoCor: SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).extras.codigoCor
                },
                adiantamentoSalarial: {
                    valor: parcelaFerias.adiantamentoSalarial
                },
                abonoPecuniario: {
                    valor: parcelaFerias.abonoPecuniario
                },
                adiantamentoDecimoTerceiro: {
                    valor: parcelaFerias.adiantamentoDecimoTerceiro
                },
                parcelasDesconto: parcelaFerias.parcelasDesconto,
                podeInterromper: parcelaFerias.quantidadeDias > 1 && (SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).descricao === SituacaoParcelaFeriasEnum.USUFRUIDA.descricao || SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).descricao === SituacaoParcelaFeriasEnum.EM_GOZO.descricao),
                selecionadaParaInterrupcao: false,
                motivoLegal: '',
                justificativaInterrupcao: '',
                dataInterrupcao: undefined,
                documentoLegal: '',
                dataPublicacaoDocumentoLegal: undefined,
                //A data mínima para a interrupção é a data de início da parcela mais 1 dia
                dataMinimaInterrupcao: new Date(getDateFromYYYYMMDD(parcelaFerias.dataInicio).setDate(getDateFromYYYYMMDD(parcelaFerias.dataInicio).getDate() + 1)),
                validacao: {
                    dataInterrupcaoInvalida: false,
                    dataPublicacaoInvalida: false,
                    justificativaInterrupcaoInvalida: false,
                    dataInterrupcaoForaPeriodoFerias: false
                }
            };
        } else {
            return this.resgatarParcelaCorrente(parcelaFerias.parcelaFilha, profundidade + 1);
        }
    }

    existeDataInicioObrigatoriaNaoInformaca(): boolean {
        return this.novasParcelasFerias.some(parcela => !parcela.dataInicio);
    }

    existeCampoObrigatorioNaoInformado(): boolean {
        return this.parcelasFeriasParaInterrupcao.some(parcela => {
            return parcela.selecionadaParaInterrupcao && (!parcela.dataInterrupcao || !parcela.motivoLegal || !parcela.documentoLegal || parcela.documentoLegal.trim().length <= 0 || !parcela.dataPublicacaoDocumentoLegal || (parcela.motivoLegal === 'Necessidade do Serviço' && (!parcela.justificativaInterrupcao || parcela.justificativaInterrupcao.length <= 0)));
        });
    }

    existeJustificativaInvalida(): boolean {
        return this.parcelasFeriasParaInterrupcao.some(parcela => {
            return parcela.validacao.justificativaInterrupcaoInvalida;
        });
    }

    existeParcelaSelecionadaParaInterrupcao(): boolean {
        return this.parcelasFeriasParaInterrupcao.some(parcela => parcela.selecionadaParaInterrupcao);
    }

    avancarWizard() {
        if (this.wizardActiveIndex < 1) {
            this.submetido = true;
            this.clearMessages();

            let podeAvancar = true;

            //Validações impeditivas
            if (!this.existeParcelaSelecionadaParaInterrupcao()) {
                this.getAlertaMsgService().error(this.msgParcelaPrecisaSerSelecionada);
                podeAvancar = false;
            }

            if (this.existeCampoObrigatorioNaoInformado()) {
                this.getAlertaMsgService().error(this.msgCamposObrigatoriosNaoPreenchidos);
                podeAvancar = false;
            }

            if (this.existeJustificativaInvalida()) {
                this.getAlertaMsgService().error(this.msgJustificativaInvalida);
                podeAvancar = false;
            }

            if (podeAvancar) {
                this.wizardActiveIndex++;

                this.parcelasFeriasParaInterrupcao.forEach(parcela => {
                    if (parcela.selecionadaParaInterrupcao) {
                        const dataInterrupcaoMaisUm = new Date(new Date(parcela.dataInterrupcao).setDate(parcela.dataInterrupcao.getDate() + 1));
                        const dataMinimaParaReprogramacao = dataInterrupcaoMaisUm < this.dataMinimaParcela ? this.dataMinimaParcela : dataInterrupcaoMaisUm;

                        if (!this.novasParcelasFerias.some(novaParcela => novaParcela.idParcelaPai === parcela.id)) {
                            //Adicionar novas parcelas
                            var novaParcela: ParcelaFeriasParaReprogramacaoHomologacao = {
                                ordem: parcela.ordem,
                                geracao: parcela.geracao + 1,
                                quantidadeDias: parcela.quantidadeDias - differenceInDays(parcela.dataInterrupcao, parcela.dataInicio),
                                situacao: {
                                    descricao: SituacaoParcelaFeriasEnum.NAO_SOLICITADA.descricao,
                                    codigoCor: SituacaoParcelaFeriasEnum.NAO_SOLICITADA.extras.codigoCor
                                },
                                validacao: {
                                    sobreposto: false,
                                    foraOrdem: false,
                                    foraJanelaProgramacao: false,
                                    quantidadeInsuficienteDias: false,
                                    dataInvalida: false
                                },
                                idParcelaPai: parcela.id,
                                //A data mínima para a reprogramação é a data de interrupção mais 1 dia
                                dataMinimaReprogramacao: dataMinimaParaReprogramacao
                            };
                            this.novasParcelasFerias.push(novaParcela);
                        } else {
                            //Atualiza a quantidade de dias e a data minima de reprogramação
                            var novaParcela = this.novasParcelasFerias.find(p => p.idParcelaPai === parcela.id);
                            novaParcela.quantidadeDias = parcela.quantidadeDias - differenceInDays(parcela.dataInterrupcao, parcela.dataInicio);
                            novaParcela.dataMinimaReprogramacao = dataMinimaParaReprogramacao;
                            this.calcularDataFim(novaParcela);
                        }
                    }
                });

                // Remover parcelas que não estão mais selecionadas
                this.novasParcelasFerias = this.novasParcelasFerias.filter(parcela => this.parcelasFeriasParaInterrupcao.some(p => p.id === parcela.idParcelaPai && p.selecionadaParaInterrupcao));

                //ordenar as parcelas
                this.novasParcelasFerias.sort((a, b) => a.ordem - b.ordem);

                this.rolarParaTopo();
                this.submetido = false;
            }
        }
    }

    existeSobreposicaoDeParcelas(): boolean {
        return this.novasParcelasFerias.some(parcela => {
            return parcela.validacao.sobreposto;
        });
    }

    existeParcelaForaPeriodoProgramacao(): boolean {
        return this.novasParcelasFerias.some(parcela => {
            return parcela.dataInicio && parcela.validacao.foraJanelaProgramacao;
        });
    }

    concluirWizard() {
        this.submetido = true;
        this.clearMessages();

        let podeReprogramar = true;

        //Validações impeditivas
        if (this.existeDataInicioObrigatoriaNaoInformaca()) {
            //Reseta todos os campos com data em branco
            this.novasParcelasFerias.forEach(novaParcela => {
                if (!novaParcela.dataInicio) {
                    novaParcela.validacao.foraJanelaProgramacao = false;
                    novaParcela.validacao.dataInvalida = false;
                }
            });

            this.getAlertaMsgService().error(this.msgCamposObrigatoriosNaoPreenchidos);
            podeReprogramar = false;
        }
        if (this.existeSobreposicaoDeParcelas()) {
            this.getAlertaMsgService().error(this.msgParcelasSobrepostas);
            podeReprogramar = false;
        }
        if (this.existeParcelaForaPeriodoProgramacao()) {
            if (this.regimeCeletistaOuAnistiado) {
                this.getAlertaMsgService().error(this.msgCeletistaAnistiadoComParcelaForaPeriodoProgramacao);
            } else {
                this.getAlertaMsgService().error(this.msgNaoCeletistaAnistiadoComParcelaForaPeriodoProgramacao);
            }
            podeReprogramar = false;
        }

        if (podeReprogramar) {
            if (this.homologacaoComAcumuloFerias) {
                this.justificativaParaAcumuloFerias = '';
                this.justificativaParaAcumuloFeriasInvalida = false;
                this.abrirConfirmAcumuloFerias();
            } else {
                this.confirmationService.confirm({
                    key: 'confirmPadrao',
                    header: 'Confirmação',
                    message: formatarMensagem(Message.CONFIRMACAO_REPROGRAMAR_FERIAS, {
                        anoExercicio: this.exercicioSelecionado.anoExercicio + ''
                    }),
                    accept: async () => {
                        this.reprogramarHomologar();
                    }
                });
            }
        }
    }

    voltarWizard() {
        if (this.wizardActiveIndex > 0) {
            this.wizardActiveIndex--;
            this.rolarParaTopo();
        }
    }

    reprogramarHomologar() {
        const parcelasAgregadas = this.gerarParcelasFeriasAgregadas();

        const reprogramarFerias: any = {
            parcelas: parcelasAgregadas
        };

        this.exerciciosService.interromperFerias(this.exercicioSelecionado.idFerias, reprogramarFerias).subscribe(data => {
            if (data.sucessoEnvioMensageria) {
                this.getAlertaMsgService().setAwatingSuccessMessage(Message.FERIAS_REPROGRAMADAS_HOMOLOGADAS_COM_SUCESSO);
            } else {
                this.getAlertaMsgService().setAwatingWarnMessage(Message.AVISO_ACAO_REALIZADA_SEM_NOTIFICACAO_AUTOMATICA);
            }

            this.voltar();
        });
    }

    selecionarParcelaParaInterromper(parcela: ParcelaFeriasParaInterrupcao) {
        this.houvePreenchimento = true;
        parcela.selecionadaParaInterrupcao = true;
    }

    desistirSelecaoParcelaParaInterromper(parcela: ParcelaFeriasParaInterrupcao) {
        parcela.motivoLegal = '';
        parcela.justificativaInterrupcao = '';
        parcela.dataInterrupcao = undefined;
        parcela.documentoLegal = '';
        parcela.dataPublicacaoDocumentoLegal = undefined;
        parcela.selecionadaParaInterrupcao = false;
        parcela.validacao.justificativaInterrupcaoInvalida = false;
        parcela.validacao.dataInterrupcaoInvalida = false;
        parcela.validacao.dataPublicacaoInvalida = false;
    }

    validarJustificativaInterrupcao(parcela: ParcelaFeriasParaInterrupcao) {
        //if (!parcela.justificativaInterrupcao || parcela.justificativaInterrupcao.trim().length < 10 || parcela.justificativaInterrupcao.trim().length > 300) {
        if (parcela.justificativaInterrupcao && (parcela.justificativaInterrupcao.trim().length < 10 || parcela.justificativaInterrupcao.trim().length > 300)) {
            parcela.validacao.justificativaInterrupcaoInvalida = true;
        } else {
            parcela.validacao.justificativaInterrupcaoInvalida = false;
        }
    }

    onJustificativaChangeInterrupcao(event, parcela: ParcelaFeriasParaInterrupcao) {
        parcela.justificativaInterrupcao = event.target.value ? event.target.value.trim() : '';
    }

    confirmarCancelarWizard() {
        if (this.houvePreenchimento) {
            this.confirmationService.confirm({
                key: 'confirmPadrao',
                header: 'Confirmação',
                message: Message.CONFIRMACAO_ABANDONAR_TELA_COM_PERDA_DE_DADOS,
                accept: async () => {
                    this.voltar();
                }
            });
        } else {
            this.voltar();
        }
    }

    voltar(): void {
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios']);
    }

    inputDataInicioChange(parcela: ParcelaFeriasParaReprogramacaoHomologacao, event) {
        if (parcela.dataInicio || event.target.value === '') {
            this.dataInicioChange(parcela);
        } else if (event.target.value) {
            if (event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                //Verificar se o event.target.value que está no formado dd/mm/yyyy é uma data válida
                const partesData = event.target.value.split('/');
                if (isValidDate(parseInt(partesData[2]), parseInt(partesData[1]), parseInt(partesData[0]))) {
                    parcela.validacao.foraJanelaProgramacao = true;
                    parcela.validacao.dataInvalida = false;
                    //Apaga a data de término
                    parcela.dataFim = undefined;
                } else {
                    parcela.validacao.foraJanelaProgramacao = false;
                    parcela.validacao.dataInvalida = true;
                    //Apaga a data de término
                    parcela.dataFim = undefined;
                }
            }
        }
    }

    inputDataPublicacaoChange(parcela: ParcelaFeriasParaInterrupcao, event) {
        if (parcela.dataPublicacaoDocumentoLegal || event.target.value === '') {
            parcela.validacao.dataPublicacaoInvalida = false;
        } else if (event.target.value) {
            if (event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                //Verificar se o event.target.value que está no formado dd/mm/yyyy é uma data válida
                const partesData = event.target.value.split('/');
                if (isValidDate(parseInt(partesData[2]), parseInt(partesData[1]), parseInt(partesData[0]))) {
                    parcela.validacao.dataPublicacaoInvalida = false;
                } else {
                    parcela.validacao.dataPublicacaoInvalida = true;
                }
            }
        }
    }

    inputDataInterrupcaoChange(parcela: ParcelaFeriasParaInterrupcao, event) {
        if (parcela.dataInterrupcao || event.target.value === '') {
            parcela.validacao.dataInterrupcaoForaPeriodoFerias = false;
            parcela.validacao.dataInterrupcaoInvalida = false;
        } else if (event.target.value) {
            if (event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                //Verificar se o event.target.value que está no formado dd/mm/yyyy é uma data válida
                const partesData = event.target.value.split('/');
                if (isValidDate(parseInt(partesData[2]), parseInt(partesData[1]), parseInt(partesData[0]))) {
                    parcela.validacao.dataInterrupcaoForaPeriodoFerias = true;
                    parcela.validacao.dataInterrupcaoInvalida = false;
                } else {
                    parcela.validacao.dataInterrupcaoForaPeriodoFerias = false;
                    parcela.validacao.dataInterrupcaoInvalida = true;
                }
            }
        }
    }

    blurDataInicioChange(parcela: ParcelaFeriasParaReprogramacaoHomologacao, event) {
        if (!parcela.dataInicio && event.target.value !== '' && !event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            parcela.validacao.foraJanelaProgramacao = false;
            parcela.validacao.dataInvalida = true;

            //Apaga a data de término
            parcela.dataFim = undefined;
        }
    }

    blurDataPublicacaoChange(parcela: ParcelaFeriasParaInterrupcao, event) {
        if (!parcela.dataPublicacaoDocumentoLegal && event.target.value !== '' && !event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            parcela.validacao.dataPublicacaoInvalida = true;
        }
    }

    blurDataInterrupcaoChange(parcela: ParcelaFeriasParaInterrupcao, event) {
        if (!parcela.dataInterrupcao && event.target.value !== '' && !event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            parcela.validacao.dataInterrupcaoForaPeriodoFerias = false;
            parcela.validacao.dataInterrupcaoInvalida = true;
        }
    }

    dataPublicacaoChange(parcela: ParcelaFeriasParaInterrupcao) {
        parcela.validacao.dataPublicacaoInvalida = false;
    }

    dataInterrupcaoChange(parcela: ParcelaFeriasParaInterrupcao) {
        parcela.validacao.dataInterrupcaoInvalida = false;
        parcela.validacao.dataInterrupcaoForaPeriodoFerias = false;
    }

    dataInicioChange(parcela: ParcelaFeriasParaReprogramacaoHomologacao) {
        //Se a data de início cair no segundo ou terceiro anos do período de programação, marca como emAcumulo
        parcela.emAcumuloSegundoPeriodo = parcela.dataInicio && parcela.dataInicio.getFullYear() === this.dataMaximaParcela.getFullYear() - 1;
        parcela.emAcumuloTerceiroPeriodo = parcela.dataInicio && parcela.dataInicio.getFullYear() === this.dataMaximaParcela.getFullYear();

        this.calcularDataFim(parcela);
    }

    calcularDataFim(parcela: ParcelaFeriasParaReprogramacaoHomologacao) {
        if (!parcela.dataInicio) {
            parcela.dataFim = undefined;
        }

        if (parcela.dataInicio) {
            parcela.dataFim = addDays(parcela.dataInicio, parcela.quantidadeDias - 1);
        }
        this.validarPeriodos();
    }

    validarPeriodos() {
        const parcelasAgregadas: ParcelaFeriasAgregadasParaValidacao[] = this.gerarParcelasFeriasAgregadas();

        parcelasAgregadas.forEach(parcela1 => {
            if (parcela1.dataFim) {
                //periodoSobreposto
                parcelasAgregadas.forEach(parcela1 => {
                    if (parcela1.dataFim) {
                        parcelasAgregadas.forEach(parcela2 => {
                            if (parcela2 !== parcela1 && parcela2.dataInicio && parcela2.dataInicio.getTime() <= parcela1.dataFim.getTime()) {
                                if (parcela2.dataFim && parcela2.dataFim.getTime() >= parcela1.dataInicio.getTime()) {
                                    parcela1.validacao.sobreposto = true;
                                    parcela2.validacao.sobreposto = true;
                                }
                            }
                        });
                    }
                });
            }

            //periodoForaJanelaProgramacao
            parcela1.validacao.foraJanelaProgramacao = false;
            if (!parcela1.validacao.sobreposto) {
                if (parcela1.dataInicio && parcela1.dataInicio < this.dataMinimaParcela) {
                    parcela1.validacao.foraJanelaProgramacao = true;
                } else if (this.regimeCeletistaOuAnistiado && parcela1.dataFim && parcela1.dataFim > this.dataMaximaParcela) {
                    //Só verifica a data de termino fora da janela de programação se for CLT/ANS
                    parcela1.validacao.foraJanelaProgramacao = true;
                }
            }
        });

        //Encontra as parcelasAgregadas no array de novasParcelasFerias e atualiza a validação de sobreposição e fora da janela de programação
        this.novasParcelasFerias.forEach(novaParcela => {
            const parcelaAgregada = parcelasAgregadas.find(parcelaAgregada => parcelaAgregada.idParcelaPai === novaParcela.idParcelaPai);
            novaParcela.validacao.sobreposto = parcelaAgregada.validacao.sobreposto;
            novaParcela.validacao.foraJanelaProgramacao = parcelaAgregada.validacao.foraJanelaProgramacao;
            novaParcela.validacao.dataInvalida = false;

            if (novaParcela.validacao.sobreposto || novaParcela.validacao.foraJanelaProgramacao) {
                novaParcela.dataFim = undefined;
            }
        });
    }

    gerarParcelasFeriasAgregadas(): ParcelaFeriasAgregadasParaValidacao[] {
        //Essa função é recursiva
        const gerarParcelasExercicioAtual: Function = (parcelaFerias: any[], profundidade = 0, idParcelaPai?: number): ParcelaFeriasAgregadasParaValidacao[] => {
            let parcelasAgregadas: ParcelaFeriasAgregadasParaValidacao[] = [];

            //Adiciona as parcelas do exercicio de férias atual
            parcelaFerias.forEach(parcelaFerias => {
                parcelasAgregadas.push({
                    id: parcelaFerias.id,
                    ordem: parcelaFerias.ordem,
                    geracao: profundidade,
                    dataInicio: getDateFromYYYYMMDD(parcelaFerias.dataInicio),
                    dataFim: getDateFromYYYYMMDD(parcelaFerias.dataFim),
                    quantidadeDias: parcelaFerias.quantidadeDias,
                    situacao: parcelaFerias.situacao,
                    adiantamentoSalarial: parcelaFerias.adiantamentoSalarial,
                    abonoPecuniario: parcelaFerias.abonoPecuniario,
                    adiantamentoDecimoTerceiro: parcelaFerias.adiantamentoDecimoTerceiro,
                    parcelasDesconto: parcelaFerias.parcelasDesconto,
                    emAcumulo: parcelaFerias.emAcumulo,
                    dataInterrupcao: parcelaFerias.dataInterrupcao,
                    motivoLegal: parcelaFerias.motivoLegal,
                    justificativaInterrupcao: parcelaFerias.justificativaInterrupcao,
                    documentoLegal: parcelaFerias.documentoLegal,
                    dataPublicacaoDocumentoLegal: parcelaFerias.dataPublicacaoDocumentoLegal,
                    idParcelaPai: parcelaFerias.idParcelaPai ? parcelaFerias.idParcelaPai : idParcelaPai,
                    validacao: {
                        sobreposto: false,
                        foraJanelaProgramacao: false
                    },
                    justificativaAcumulo: parcelaFerias.emAcumuloSegundoPeriodo || parcelaFerias.emAcumuloTerceiroPeriodo ? this.justificativaParaAcumuloFerias : null
                });

                if (parcelaFerias.parcelaFilha) {
                    parcelasAgregadas = parcelasAgregadas.concat(gerarParcelasExercicioAtual([parcelaFerias.parcelaFilha], profundidade + 1, parcelaFerias.id));
                }
            });

            return parcelasAgregadas;
        };

        const parcelasAgregadas: ParcelaFeriasAgregadasParaValidacao[] = gerarParcelasExercicioAtual(this.exercicioSelecionado.parcelas);

        this.novasParcelasFerias.forEach(novaParcela => {
            const parcelaParaInterrupcao = this.parcelasFeriasParaInterrupcao.find(parcelaParaInterrupcao => parcelaParaInterrupcao.id === novaParcela.idParcelaPai);
            const parcelaAgregada = parcelasAgregadas.find(parcelaAgregada => parcelaAgregada.id === novaParcela.idParcelaPai);

            //Atualiza as parcelas que foram interrompidas
            parcelaAgregada.dataFim = new Date(new Date(parcelaParaInterrupcao.dataInterrupcao).setDate(parcelaParaInterrupcao.dataInterrupcao.getDate() - 1));
            parcelaAgregada.quantidadeDias = differenceInDays(parcelaParaInterrupcao.dataInterrupcao, parcelaAgregada.dataInicio);
            parcelaAgregada.situacao = SituacaoParcelaFeriasEnum.INTERROMPIDA.descricao;
            parcelaAgregada.dataInterrupcao = parcelaParaInterrupcao.dataInterrupcao;
            parcelaAgregada.motivoLegal = parcelaParaInterrupcao.motivoLegal;
            parcelaAgregada.justificativaInterrupcao = parcelaParaInterrupcao.justificativaInterrupcao;
            parcelaAgregada.documentoLegal = parcelaParaInterrupcao.documentoLegal;
            parcelaAgregada.dataPublicacaoDocumentoLegal = parcelaParaInterrupcao.dataPublicacaoDocumentoLegal;

            //Inclui as novas parcelas de férias criadas para reprogramação
            parcelasAgregadas.push({
                ordem: novaParcela.ordem,
                geracao: novaParcela.geracao,
                dataInicio: novaParcela.dataInicio,
                dataFim: novaParcela.dataFim,
                quantidadeDias: novaParcela.quantidadeDias,
                situacao: novaParcela.situacao.descricao,
                emAcumulo: novaParcela.emAcumuloSegundoPeriodo || novaParcela.emAcumuloTerceiroPeriodo,
                idParcelaPai: novaParcela.idParcelaPai,
                validacao: {
                    sobreposto: false,
                    foraJanelaProgramacao: false
                },
                justificativaAcumulo: novaParcela.emAcumuloSegundoPeriodo || novaParcela.emAcumuloTerceiroPeriodo ? this.justificativaParaAcumuloFerias : null
            });
        });

        //Ordena as parcelas
        parcelasAgregadas.sort((a, b) => a.ordem - b.ordem);

        return parcelasAgregadas;
    }

    abrirConfirmAcumuloFerias() {
        this.confirmationService.confirm({
            key: 'confirmAcumuloFerias',
            header: 'Confirmação',
            accept: async () => {
                this.reprogramarHomologarComAcumuloFerias();
            }
        });
    }

    reprogramarHomologarComAcumuloFerias(): void {
        let podeReprogramarHomologar = true;

        // Validação da justificativa
        this.validarJustificativaParaAcumuloFerias();
        if (this.justificativaParaAcumuloFeriasInvalida) {
            podeReprogramarHomologar = false;
        }

        if (!podeReprogramarHomologar) {
            setTimeout(() => {
                this.abrirConfirmAcumuloFerias();
            }, 200);
        } else {
            this.reprogramarHomologar();
        }
    }

    validarJustificativaParaAcumuloFerias() {
        if (!this.justificativaParaAcumuloFerias || this.justificativaParaAcumuloFerias.trim().length < 10 || this.justificativaParaAcumuloFerias.trim().length > 300) {
            this.justificativaParaAcumuloFeriasInvalida = true;
        } else {
            this.justificativaParaAcumuloFeriasInvalida = false;
        }
    }

    onJustificativaParaAcumuloFeriasChange(event) {
        this.justificativaParaAcumuloFerias = event.target.value ? event.target.value.trim() : '';
    }
}
